var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsCat2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.693,
    height: 30.021,
    viewBox: "0 0 29.693 30.021",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "settings_24dp_E8EAED_FILL1_wght300_GRAD0_opsz24_2_",
    "data-name": "settings_24dp_E8EAED_FILL1_wght300_GRAD0_opsz24 (2)",
    d: "M115.36-829.978l-.6-4.813a7.248,7.248,0,0,1-1.3-.6,8.418,8.418,0,0,1-1.193-.82l-4.458,1.884-3.646-6.32,3.856-2.914q-.055-.352-.077-.708t-.023-.708q0-.337.023-.685t.077-.761l-3.856-2.914,3.646-6.29,4.442,1.869a10.156,10.156,0,0,1,1.22-.828,8.064,8.064,0,0,1,1.275-.6L115.36-860h7.293l.6,4.828a7.446,7.446,0,0,1,1.287.6,10.627,10.627,0,0,1,1.163.813l4.5-1.869,3.646,6.29-3.917,2.96a3.723,3.723,0,0,1,.093.716q.008.333.008.67,0,.322-.015.655a4.563,4.563,0,0,1-.109.761l3.886,2.929-3.647,6.32-4.448-1.9a10.341,10.341,0,0,1-1.2.828,7.221,7.221,0,0,1-1.252.588l-.6,4.828Zm3.665-10.271a4.571,4.571,0,0,0,3.356-1.384,4.57,4.57,0,0,0,1.384-3.356,4.57,4.57,0,0,0-1.384-3.356,4.571,4.571,0,0,0-3.356-1.384,4.559,4.559,0,0,0-3.368,1.384,4.591,4.591,0,0,0-1.372,3.356,4.591,4.591,0,0,0,1.372,3.356A4.559,4.559,0,0,0,119.025-840.249Z",
    transform: "translate(-104.16 860)",
    fill: "#85899c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsCat2);
export default __webpack_public_path__ + "static/media/settings_cat_2.40a3c899d42fcd672e87f89b8e33fb47.svg";
export { ForwardRef as ReactComponent };